import React from 'react';
import FuseAnimate from '@fuse/core/FuseAnimate';
import { useForm } from '@fuse/hooks';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import HeaderAuth from 'app/main/pages/auth/headerAuth/HeaderAuth'; 
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import { RiLockPasswordFill } from "react-icons/ri";
import axios from 'axios';
import  toast, { Toaster } from 'react-hot-toast';
import {Plane} from 'react-loader-spinner'
import { useHistory } from "react-router-dom";


const useStyles = makeStyles(theme => ({
	root: {
		background: `radial-gradient(${theme.palette.background.paper} 100%, ${theme.palette.background.paper} 100%)`,
		color: theme.palette.primary.contrastText
	},
	containerPassword: {
		boxShadow: 'none',
		maxWidth: '600px',
		margin: 'auto',
		fontSize: '14px'
	},
	logo: {
		width: '100%',
		marginBottom: '12px'
	},
	logoLock:{
		width: '64px',
		margin: 'auto',
	},
	greyBox: {
		padding: '20px 20px',
		background: '#f9f9f9',
		border: 'solid thin #ccc',
		marginBottom: '35px',
		width: '100%',
		textAlign: 'center',
	},
	notif: {
		marginBottom: '10px',
		fontWeight: 'bold',
		fontSize: '14px',
		color: '#575757',
		'&:last-child':{
			marginBottom: '0px',
		}
	},
	reset:{
		fontSize:'3rem',
		fontWeight:'bold',
		color: theme.palette.scaiPro.primary,
	},
	goBackLogin:{
		color: `${theme.palette.scaiPro.primary}!important`,
	},
	icon:{
		color: '#6581c2',
		width: '64px',
		height: '64px',
		margin: 'auto',
		display: 'block',
	},
	toasterStyle:{
        marginTop:'100px',
    },
	loadingContainer:{
		display: 'inline-grid',
	},
	backToLogin:{
		cursor:'pointer',
		color: '#497FB1!important',
		'&:hover':{
			textDecoration:'underline',
		}
	}
}));

function ForgotPasswordPage() {
	const classes = useStyles();
	const {t} = useTranslation('auth');
	const [processResendEmailVerif, setProcessResendEmailVerif] = React.useState(false);
	let history = useHistory();
	const { form, handleChange, resetForm } = useForm({
		email: ''
	});

	function isFormValid() {
		return form.email.length > 0;
	}

	function handleSubmit(ev) {
		ev.preventDefault();
		resetForm();
		

		let send_data = {
			"email": form.email,
		}
		setProcessResendEmailVerif(true)
		return new Promise((resolve, reject) => {
			axios.post(process.env.REACT_APP_SERVER + '/api/auth/generate-forgot-password-token', send_data).then(response => {
				toast.dismiss();
				if (response.data) {
					resolve(response.data);
					setTimeout(()=>{
						toast.success(t('forgot_password_email_sent'));
						setProcessResendEmailVerif(false)
					},500) 
					setTimeout(()=>{
						history.push({pathname:'/login'})
					},1500)
					
				} else {
					toast.error(t('error_when_send_email'));
					setProcessResendEmailVerif(false)
					reject(response.data.error);
				}
			}).catch(function (error) {
				setProcessResendEmailVerif(false)
				toast.error(t('error_when_send_email'));
				if (error.response) {
				  // The request was made and the server responded with a status code
				  // that falls out of the range of 2xx
				  console.log(error.response.data);
				  console.log(error.response.status);
				  console.log(error.response.headers);
				} else if (error.request) {
				  // The request was made but no response was received
				  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
				  // http.ClientRequest in node.js
				  console.log(error.request);
				} else {
				  // Something happened in setting up the request that triggered an Error
				  console.log('Error', error.message);
				}
				console.log(error.config);
			  });;
			});
		
	}

	return (
		<>
			<Toaster
                toastOptions={{
                    className:classes.toasterStyle,
                    
                }}
             /> 
			<HeaderAuth />
			<div className={clsx(classes.root, 'flex flex-col flex-auto flex-shrink-0 items-center justify-center p-32')}>
				<div className="flex flex-col items-center justify-center w-full">
					<FuseAnimate /*animation="transition.expandIn"*/>
						<Card className={clsx(classes.containerPassword, 'w-full max-w-640')}>
							<CardContent className="flex flex-col items-center justify-center p-32">
								
								<span className={clsx("flex justify-center text-center w-full mt-16", classes.reset)}>
									{t('reset_your_password')}
								</span>

								<div className="w-128 m-32">
									<RiLockPasswordFill className={classes.icon} />
								</div>

								{processResendEmailVerif === false ?
								<>
								<div className={classes.greyBox}>
									<p className={classes.notif}>{t('enter_your_previously_email_registered')}</p>
									<p className={classes.notif}>{t('a_generated_code_will_be_send_to_your_email')}</p>
								</div>

								<form
									name="recoverForm"
									noValidate
									className="flex flex-col justify-center w-full"
									onSubmit={handleSubmit}
								>
									<TextField
										className="mb-16"
										label={t("email")}
										autoFocus
										type="email"
										name="email"
										value={form.email}
										onChange={handleChange}
										variant="outlined"
										required
										fullWidth
									/>

									<Button
										variant="contained"
										color="primary"
										className="w-224 mx-auto mt-16 bt-update"
										aria-label="Reset"
										disabled={!isFormValid()}
										type="submit"
									>
										{t('send_reset_link')}
									</Button>
								</form>

								<div className="flex flex-col items-center justify-center pt-32 pb-24">
									<Link className={clsx("font-medium", classes.goBackLogin)} to="/login">
										{t('go_back_to_login_page')}
									</Link>
								</div>
								</>
								:
								<div className={classes.greyBox}>
									<p className={classes.notif}>{t('processing_reset_password_email')}</p>
									<div className={classes.loadingContainer}>
										<Plane ariaLabel="loading-indicator" />
									</div>
								</div>
								}
							</CardContent>
						</Card>
					</FuseAnimate>
				</div>
			</div>
		</>
	);
}

export default ForgotPasswordPage;
